import {
  setupOnFailureBridgeCBParams,
  setupOnSuccessBridgeCBParams
} from './definitions';

export function setupOnSuccessBridgeCB({
  globalEnv,
  onSuccessBridgeCB,
  onFailureBridgeCB,
  resolve
}: setupOnSuccessBridgeCBParams) {
  globalEnv[onSuccessBridgeCB] = ((
    fnName: string,
    fnName2: string,
    resolve: (param?: any) => any
  ): ((_arg: any) => void) => {
    return function(data: any) {
      let result = data;
      try {
        if (data && typeof data === 'string') result = JSON.parse(data);
      } catch (error) {
        console.error(error);
      }
      resolve(result);
      try {
        delete globalEnv[fnName];
        delete globalEnv[fnName2];
      } catch (error) {
        console.error(error);
        globalEnv[fnName] = undefined;
        globalEnv[fnName2] = undefined;
      }
    };
  })(onSuccessBridgeCB, onFailureBridgeCB, resolve);
}

export function setupOnFailureBridgeCB({
  globalEnv,
  onFailureBridgeCB,
  reject,
  genericRejection
}: setupOnFailureBridgeCBParams) {
  globalEnv[onFailureBridgeCB] = ((
    fnName: string,
    reject: (param?: any) => any,
    error: any
  ): (() => void) => {
    return function() {
      try {
        delete globalEnv[fnName];
      } catch (error) {
        globalEnv[fnName] = undefined;
      }
      reject(error);
    };
  })(onFailureBridgeCB, reject, genericRejection);
}

export function getUID(): string {
  return `${Date.now()}${(Math.random() * 1e5).toFixed()}`;
}
